import { FlaskConical, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

type SandboxModeBannerProps = {
  onDisable: () => void;
  disabling?: boolean;
};

export function SandboxModeBanner({ onDisable, disabling = false }: SandboxModeBannerProps) {
  return (
    <div className="sticky top-0 z-50 w-full border-b border-amber-500/40 bg-amber-500/15 backdrop-blur-sm">
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-2 max-w-6xl">
        <div className="flex items-center gap-2 text-sm text-amber-700 dark:text-amber-300">
          <FlaskConical className="h-4 w-4 shrink-0" />
          <span className="font-semibold">Sandbox mode active</span>
          <span className="hidden sm:inline text-amber-600/80 dark:text-amber-400/80">
            — no real charges or subscriptions. Domains activate instantly.
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 gap-1.5 text-amber-700 hover:bg-amber-500/20 hover:text-amber-800 dark:text-amber-300 dark:hover:text-amber-200"
          onClick={onDisable}
          disabled={disabling}
        >
          <X className="h-3.5 w-3.5" />
          {disabling ? 'Disabling…' : 'Disable'}
        </Button>
      </div>
    </div>
  );
}
